import * as React from 'react';
import * as _ from 'lodash';
import GoogleMapReact from 'google-map-react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { fetchCategoriesStoreWP } from '../actions/categories';
import mapStateToProps from '../utils/mapStateToProps';
import mapDispatchToProps from '../utils/mapDispatchToProps';
import ListStore from './component/ListStore';
import { mapOptions } from '../helpers/index';

class Stores extends React.Component<any, any> {

	constructor(props: any) {
		super(props);
		this.state = {
			loading: true
		}
	}

	componentDidMount() {
		this.props.fetchCategoriesStoreWP({
			term: 'store_categories',
			number: 100
		});
		document.title = this.props.t('stores');
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.categoriesStoreWP.loading == false) {
			this.setState({
				loading: false
			})
		}
	}

	shouldComponentUpdate(nextProps) {
		if (nextProps.categoriesStoreWP.loading) {
			return false;
		} else {
			return true;
		}
	}

	onChildClick = (key, childProps) => {
		this.props.history.push(`/store/${key}/${childProps.slug}`);
	};

	findChild = (data, par) => {
		var strg = [];
		data.map(item => {
			if (item.parent == par) {
				strg.push({
					name: item.name,
					id: item.term_id,
					slug: item.slug,
					count: item.count
				});
			}
		});

		var array_map = strg.map((item, index) => {
			return <li key={index}><Link to={`/store/${item.id}/${item.slug}`}><span className="name">{item.name}</span><span
				className="count">{item.count}</span></Link></li>;
		});

		return array_map;
	};

	render() {

		const { categoriesStoreWP } = this.props;

		var array_sort = _.orderBy(
			categoriesStoreWP.data,
			[
				function(item) {
					return _.chain(item).get('custom_fields').find({key: 'order'}).get('value').value();
				}
			],
			['asc']
		);

		var list_address = array_sort.map((item) => {
			if (item.parent == '0' && item.term_id != process.env.REACT_APP_CATE_DEFAULT) {
				return (
					<div key={item.term_id}>
						<div className="filter set opened" id="opened">
							<h2>
								<img src={require('../img/icon-opened.png')} width={15}/>
								{item.name}
							</h2>
							<ul>
								{this.findChild(array_sort, item.term_id)}
							</ul>
						</div>
						<div className="horizontal divider"/>
					</div>
				);
			} else if(item.parent == process.env.REACT_APP_CATE_DEFAULT) {
				return (
					<div key={item.term_id}>
						<div className="filter set opened" id="opened">
							<h2>
								<img src={require('../img/icon-opened.png')} width={15}/>
								{item.name}
							</h2>
							<ul>
								{this.findChild(array_sort, item.term_id)}
							</ul>
						</div>
						<div className="horizontal divider"/>
					</div>
				);
			}
		});

		var list_store = categoriesStoreWP.data.map(item => {
			if (item.parent != '0' && item.parent != process.env.REACT_APP_CATE_DEFAULT) {
				if(item.count == 0) {
					return (
						<ListStore key={item.term_id} slug={item.slug} lat={item.custom_fields[1]['value']}
						           lng={item.custom_fields[2]['value']} img={require(`../img/icon-future.png`)}/>
					);
				} else {
					return (
						<ListStore key={item.term_id} slug={item.slug} lat={item.custom_fields[1]['value']}
						           lng={item.custom_fields[2]['value']} img={require(`../img/icon-opened${item.count}` + `.png`)}/>
					);
				}
			}
		});

		return (
			<div className="mapContainer">
				<div className="section mapWrap">
					<div id="map">
						<GoogleMapReact
							bootstrapURLKeys={{ key: process.env.REACT_APP_KEY_GOOGLE_MAP}}
							defaultCenter={[16.2414252, 109.6139389]}
							defaultZoom={2}
							options={mapOptions}
							onChildClick={this.onChildClick}
						>
							{list_store}
						</GoogleMapReact>
					</div>
				</div>
				<div className="filters panel">
					{list_address}
				</div>
				{this.state.loading ? <div className="loadingPage active"> <img src={require('../img/Spin-1s-58px.gif')}/></div> : '' }
			</div>
		);
	}
}

export default connect(mapStateToProps([
	'categoriesStoreWP'
]), mapDispatchToProps({
	fetchCategoriesStoreWP
}))(translate('translations')(Stores));



// WEBPACK FOOTER //
// ./src/containers/Stores.tsx